import React from "react";

import { css, cva, cx } from "../../styled-system/css";

export const paperStyle = css.raw({
  backgroundColor: "white",
  borderRadius: "4px",
  color: "rgba(0, 0, 0, 0.87)",
});

export const PaperStyle = cva({
  base: {
    backgroundColor: "white",
    boxShadow: "0px 1px 2px 0px #0000000D",
  },
  variants: {
    borderRadius: {
      "4px": { borderRadius: "4px" },
      "8px": { borderRadius: "8px" },
      "12px": { borderRadius: "12px" },
    },
    display: { block: { display: "block" } },
    marginTop: {
      "12px": { marginTop: "12px" },
    },
    marginX: {
      "16px": { marginLeft: "16px", marginRight: "16px" },
    },
    maxHeight: {
      stretch: { maxHeight: "stretch" },
    },
    maxWidth: {
      stretch: { maxWidth: "stretch" },
    },
    minWidth: { 0: { minWidth: 0 } },
    padding: {
      "16px": { padding: "16px" },
      "16px 12px": { padding: "16px 12px" },
      "24px": { padding: "24px" },
    },
    width: {
      stretch: { width: "stretch" },
    },
  },
});

/**
 * @deprecated 代わりに`PaperStyle`を使用する。
 */
export const paperStyles = PaperStyle;

export type PaperProperties = React.ComponentPropsWithRef<"div">;
export function Paper({ children, className, ...properties }: PaperProperties) {
  return (
    <div {...properties} className={cx(css(paperStyle), className)}>
      {children}
    </div>
  );
}
